import { NotificationConfiguration } from '../notification.templates';

export const MEETING_MINUTES_SIGNING_COMPLETE_TEMPLATE: NotificationConfiguration = {
  inapp: `All signatories have signed the meeting mintues.`,
  email: {
    ctaKey: 'go_to_meeting_minutes',
  },
};
